import { Pipe, PipeTransform } from '@angular/core';
import { Tariff, TariffPeriodUnit } from './tariff.model';
import { TariffService } from '../../core/services/tariff.service';

@Pipe({
  name: 'tariffPrice',
})

export class TariffPricePipe implements PipeTransform {
  constructor(
    private tariffService: TariffService,
  ) {
  }

  transform(tariff: Tariff, displayedPeriod: TariffPeriodUnit = 'MONTH'): number {
    if (!tariff.periodPrice) {
      return 0;
    }

    if (displayedPeriod === 'YEAR') {
      return tariff.periodPrice * this.tariffService.getTariffPeriodUnitMultiplier(tariff);
    }
    if (displayedPeriod === 'MONTH') {
      return tariff.periodPrice * this.tariffService.getTariffPeriodUnitMultiplier(tariff) / 12;
    }

    return 0;
  }
}
